import * as s from "styles/ModalCommonStyled";
import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import Input from "components/atoms/input/Input";
import BigButton from "components/atoms/buttons/BigButton";
import { UPDATE_TYPE } from "./AddGroupsContainer";
import { SearchRecorder } from "components/element/search/SearchRecorder";
import { CreateRecorderGroupRequest } from "api/interfaces/recorderInterface.interface";
import DeleteConfirmModal from "components/templates/modal/small/confirm/delete/DeleteConfirmModal";
import {
  Validate,
  ValidateMsg,
} from "api/interfaces/commonInterface.interface";
import { ValidateWord } from "components/atoms/text/Text";
interface Props {
  onModal: (type?: string) => void;
  accountId: string;
  onChangeRecorderGroupInfo: (
    type: UPDATE_TYPE,
    value: string | string[]
  ) => void;
  onClickCreate: () => void;
  selectData?: CreateRecorderGroupRequest & { hostValidation?: boolean };
  isEditModal?: boolean;
  setIsDeleteConfirm?: (confirm: boolean) => void;
  isConfirm: boolean;
  onDelete: (value: boolean) => void;
  onConfirmDelete: () => void;
  onClickUpdate: () => void;
  recorderGroupValidate: Validate;
  recorderGroupValidateMsg: ValidateMsg;
  initRecorderGroupValidate: (field: string) => void;
  userId: string | undefined;
  disabled: boolean;
  disabledDelete: boolean;
}

export function AddGroupsPresenter(props: Props): JSX.Element {
  let groupCreaterUserId: string | undefined;
  if (!props.selectData) {
    groupCreaterUserId = props.userId;
  } else if (!props.selectData.hostValidation) {
    groupCreaterUserId = undefined;
  } else {
    groupCreaterUserId = props.selectData.userId;
  }

  return (
    <BigPopupTemplate
      title={props.isEditModal ? "Edit Recorder Group" : "Add Recorder Group"}
      onModal={props.onModal}
    >
      <s.AddWrapper>
        <ModalInput label="Group Name" essential>
          <Input
            placeholder="Enter group name here."
            value={props.selectData?.name}
            isValidated={props.recorderGroupValidate.isRecorderGroupName}
            onChange={(e) =>
              props.onChangeRecorderGroupInfo(UPDATE_TYPE.NAME, e.target.value)
            }
            onFocus={() => {
              props.initRecorderGroupValidate("isRecorderGroupName");
            }}
            maxLength={255}
            data-testid="recorders-add-groups-input-change-info"
          />

          <ValidateWord data-testid="recorders-add-groups-validate-name">
            {props.recorderGroupValidateMsg.isRecorderGroupName}
          </ValidateWord>
        </ModalInput>

        <ModalInput label="Description">
          <Input
            placeholder="Enter group description here."
            value={props.selectData?.description}
            onChange={(e) =>
              props.onChangeRecorderGroupInfo(
                UPDATE_TYPE.DESC,
                e?.target?.value
              )
            }
            maxLength={255}
            data-testid="recorders-add-groups-input-change-info-2"
          />
        </ModalInput>

        <ModalInput label="Add Recorder" essential>
          <SearchRecorder
            accountId={props.accountId}
            selectedRow={props.selectData?.mergedSystemIds}
            onSelectedRowsChange={(value: string[]) =>
              props.onChangeRecorderGroupInfo(UPDATE_TYPE.RECORDER, value)
            }
            hideTitle
            userId={groupCreaterUserId}
          />

          <ValidateWord data-testid="recorders-add-groups-validate-recorder">
            {props.recorderGroupValidateMsg.mergedSystemIds}
          </ValidateWord>
        </ModalInput>
        <s.ButtonWrapper>
          {props.isEditModal && (
            <BigButton
              buttonType="warning"
              label="Delete"
              disabled={props.disabledDelete}
              onClickBtn={() =>
                props.setIsDeleteConfirm !== undefined
                  ? props.setIsDeleteConfirm(true)
                  : null
              }
              data-testid="recorders-add-groups-button-set-is-delete-confirm"
            />
          )}

          {props.isEditModal ? (
            <BigButton
              label="Save"
              disabled={props.disabled}
              onClickBtn={props.onClickUpdate}
              data-testid="recorders-add-groups-button-click-update"
            />
          ) : (
            <BigButton
              label="Save"
              disabled={props.disabled}
              onClickBtn={props.onClickCreate}
              data-testid="recorders-add-groups-button-click-create"
            />
          )}

          {props.isEditModal && props.isConfirm && (
            <DeleteConfirmModal
              label="Recorder Group"
              onDelete={() => props.onDelete(false)}
              onConfirmDelete={props.onConfirmDelete}
            />
          )}
        </s.ButtonWrapper>
      </s.AddWrapper>
    </BigPopupTemplate>
  );
}
